<template>


<div class="container">
	<div class="row">
		<div class="col-lg-8">
		<h1>Technology Research</h1>
		<small class="text-muted">
			Right tool and technology empowers people and motivates them to create and excel
		</small>
<p class="lead">
</p>


	<div class="card mx-sm-4 my-4">
		<div class="card-body bg-secondary">
			<h5 class="card-title">How to choose the best tool for the job?</h5>
			<p>
				<ol>
					<li>Understand your team: what they use, where and why, and why they don't use something else. How often they change tools and technologies, and how long your developers stay on one project.</li>
					<li>Analyze the project you work on, find what could be improved, what others use in similar projects, and why they use the tools.</li>
					<li> Find alternatives to the tools that could be used on your project and compare them.</li>
					<li>Simulate use of the new tool, check support and documentation quality, estimate your team training requirements and cost.</li>
				</ol>
			</p>
		</div>
	</div>



<p>
You need to do technology research to keep track of the best tools, technologies and techniques that could be used in your company, and do it regularly. But if you can't we can help you with that.
</p>

<p>
	Working with many companies we have the opportunity to see what others use and their successes and failures with certain technologies and tools. We also conduct primary and secondary research on the newest technologies used in the software development industry, to make sure we can update our client with the most efficient solutions on the market. 
</p>

		</div>
		<div class="col-lg-4">

			<div class="card my-5">
				<div class="card-body bg-primary text-secondary">
					<h5 class="card-title text-secondary">Is everything secure? What needs the most urgent improvement?</h5>
					<p class="card-text">
						If you are a target-oriented company, you need to prioritise your projects right. You need to know your strength and weaknesses. We offer an independent technical assessment of your IT infrastructure, products and processes.
					</p>
					<a href="#/process_assessments" class="btn btn-outline-white">More info</a>
				</div>
			</div>

			<div class="card my-5">
				<div class="card-body bg-warning text-secondary">
					<h5 class="card-title text-secondary">Infrastructure, Deployments, Monitoring</h5>
					<p class="card-text">Whenever you need 24/7 monitoring and support services, or just regular application deployment and system updates, we can help you</p>
					<a href="#/maintenance_and_supprt" class="btn btn-outline-white">More info</a>
				</div>
			</div>


		</div>
	</div>
</div>


</template>

<script>
export default {
	data() {
		return {
			metadata: {
				section: "service",
				title: "Technology Research"
			}
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		}
	},
	mounted: function() {
		this.loadToParent();	
	},
}
</script>
